/**
 * Minimal Node `process` global for the web bundle.
 *
 * React Native packages assume a Metro/Node-ish environment and reference the
 * bare `process` global. webpack 5 stopped polyfilling Node globals, so in a
 * browser that throws `ReferenceError: process is not defined`.
 *
 * That failure is easy to miss: react-native-gesture-handler loads Reanimated
 * with `try { require('react-native-reanimated') } catch {}`, so the error is
 * swallowed and Reanimated is left half-initialised. The first symptom is an
 * unrelated-looking "Cannot read properties of undefined (reading
 * 'createAnimatedComponent')" much later in the app.
 *
 * Provided via webpack's ProvidePlugin, which injects it only into modules
 * that actually reference `process`. Writing it here rather than adding the
 * `process` npm package keeps the dependency list unchanged.
 */

const processShim = {
  env: {
    NODE_ENV: process.env.NODE_ENV,
  },
  platform: 'browser',
  browser: true,
  version: '',
  versions: {},
  argv: [],
  nextTick(callback, ...args) {
    Promise.resolve().then(() => callback(...args));
  },
  cwd() {
    return '/';
  },
  on() {},
  off() {},
  once() {},
  emit() {},
};

module.exports = processShim;
